import { render } from "./Signature.vue?vue&type=template&id=d619b41c&ts=true"
import script from "./Signature.vue?vue&type=script&lang=ts"
export * from "./Signature.vue?vue&type=script&lang=ts"

import "./Signature.vue?vue&type=style&index=0&id=d619b41c&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__